import { supabase } from './supabase';
import { getProductosCache, saveProductosCache } from './offline/offlineDb';

const GENERIC_ERROR = 'No se pudo cargar el catálogo de productos.';

// Lectura: se apoya en la policy RLS de productos_aplicacion
// ("activo = true" para authenticated), igual que especies/aplicadores/
// responsables_tecnicos — no hace falta Edge Function para listar.
export async function listarProductosAplicacion() {
  const { data, error } = await supabase
    .from('productos_aplicacion')
    .select('id, nombre')
    .order('orden', { ascending: true })
    .order('nombre', { ascending: true });

  if (error) {
    return { ok: false, message: GENERIC_ERROR };
  }

  return { ok: true, productos: data ?? [] };
}

// Combina red + cache local (IndexedDB, ver offlineDb.js) para que el
// selector de productos del wizard de aplicaciones funcione también sin
// conexión: online refresca la cache con el catálogo vigente; si falla
// (offline, o Supabase no responde) cae a la última copia cacheada.
export async function obtenerCatalogoProductosAplicacion() {
  const online = await listarProductosAplicacion();
  if (online.ok) {
    saveProductosCache(online.productos).catch(() => {});
    return online;
  }

  let cached = null;
  try {
    cached = await getProductosCache();
  } catch {
    cached = null;
  }

  if (cached && cached.length > 0) {
    return { ok: true, productos: cached };
  }

  return { ok: false, message: GENERIC_ERROR };
}
